<ng-container *transloco="let t; read: 'auth'">
  <form
    class="flex flexDirCol mtl alignCenter"
    [formGroup]="loginForm"
    (submit)="onSubmit()"
  >
    <img src="/assets/logo/logo.svg" width="350" class="mbm"/>

    <kendo-textbox
      [style.width.px]="350"
      [placeholder]="t('tenant')"
      formControlName="tendantId"
      class="mbs"
    ></kendo-textbox>

    <kendo-textbox
      [style.width.px]="350"
      [placeholder]="t('emailPlaceholder')"
      formControlName="email"
      class="mbs"
    ></kendo-textbox>

    <input
      kendoTextBox
      [style.width.px]="350"
      type="password"
      formControlName="password"
      class="mbs"
    >

    <button
      [disabled]="loginForm.invalid"
      type="submit"
      kendoButton
      fillMode="solid"
      size="large"
      rounded="large"
      [themeColor]="isLoading ? 'warning' : 'primary'"
    >{{isLoading ? t('loginLoading') : t('login')}}</button>
  </form>
  <span id="version">Version {{version}}</span>
</ng-container>
